import { Cookies } from "react-cookie";
import { isServer, Store } from "@/redux/store";

import serverContextStorage from "./serverContextStorage";

class ContextStorage {
  private static clientData: StorageData;

  public static get cookies(): Cookies {
    return this.storage.cookies!;
  }

  public static get store(): Store {
    return this.storage.store!;
  }

  public static get userIp(): string | undefined {
    return this.storage.userIp;
  }

  public static setClientStorageData(data: StorageData) {
    if (isServer)
      throw new Error("This method is only available on the client");
    this.clientData = data;
  }

  public static setServerStorageData(data: StorageData) {
    if (!isServer)
      throw new Error("This method is only available on the server");

    this.getServerContextStorage().store = data.store;
    this.getServerContextStorage().cookies = data.cookies;
    this.getServerContextStorage().userIp = data.userIp;
  }

  private static get storage(): StorageData {
    return isServer
      ? this.getServerContextStorage()
      : this.getClientContextStorage();
  }

  private static getServerContextStorage(): StorageData {
    if (!isServer)
      throw new Error("This method is only available on the server");

    return serverContextStorage.getStore();
  }

  private static getClientContextStorage(): StorageData {
    if (isServer)
      throw new Error("This method is only available on the client");

    return this.clientData;
  }
}

export type StorageData = {
  cookies: Cookies;
  store: Store;
  userIp?: string;
};

export default ContextStorage;
